
var mode = process.env.REACT_APP_ENV || 'production';

var LocalKeys = {
    API_URL                 : 'http://localhost:4040/v4/leaderboard/v1',
}

var Local2Keys = {
    API_URL                 : 'http://localhost:5050/v4/leaderboard/v1',
}

var Local3Keys = {
    API_URL                 : 'http://localhost:6060/v4/leaderboard/v1',
}

var Local4Keys = {
    API_URL                 : 'http://localhost:7070/v4/leaderboard/v1',
}

var Local5Keys = {
    API_URL                 : 'http://localhost:8080/v4/leaderboard/v1',
}

var DevKeys = {
    API_URL                 : 'https://dev-rest.myoptimity.com/v4/leaderboard/v1',
}

var ProdKeys = {
    API_URL                 : 'https://rest.myoptimity.com/v4/leaderboard/v1',
};

var Prod2Keys = {
    API_URL                 : 'https://us.rest.myoptimity.com/v4/leaderboard/v1',
};

var Prod3Keys = {
    API_URL                 : 'https://carrot.rest.myoptimity.com/v4/leaderboard/v1',
};

var Prod4Keys = {
    API_URL                 : 'https://carrot-us.rest.myoptimity.com/v4/leaderboard/v1',
};


var Keys = null;
switch(mode) {
    case 'local':
        Keys = LocalKeys; 
    break;
    case 'local2':
        Keys = Local2Keys; 
    break;
    case 'local3':
        Keys = Local3Keys; 
    break;
    case 'local4':
        Keys = Local4Keys; 
    break;
    case 'local5':
        Keys = Local5Keys; 
    break;
    case 'dev':
        Keys = DevKeys; 
    break;
    case 'prod':
        Keys = ProdKeys; 
    break;
    case 'prod2':
        Keys = Prod2Keys; 
    break;
    case 'prod3':
        Keys = Prod3Keys; 
    break;
    case 'prod4':
        Keys = Prod4Keys; 
    break;
    default: 
        Keys = DevKeys;
}


export default Keys;
